import { Typography, Button } from "@mui/material";
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PageContent } from "../../components";

const ActionPlanContent = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/ActionPlan");
  };

  return (
    <PageContent title = "Action Plan">
      <Typography variant="body1">Details for questionnaire with ID: {id}</Typography>
      <Button variant="contained" color="primary" onClick={handleBackClick} style={{ marginTop: "20px" }}>
        Back to Grid
      </Button>
    </PageContent>
  );
};

export default ActionPlanContent;
